import * as React from 'react'
import { Moment } from 'moment-timezone'
import Datetime from 'react-datetime'

interface ITimePickerProps {
  onChange: (date: Moment | string) => void,
  classes? : string,
  disabled?: boolean
  value?: any
}

const TimePicker: React.FC<ITimePickerProps> = props => {
  const {} = props
  return (
    <Datetime
      inputProps={{
        className: `form-control ${props.classes}`,
        readOnly: true,
        placeholder: '07:00 AM',
        disabled: props.disabled
      }}
      onChange={props.onChange}
      dateFormat={false}
      defaultValue={'07:00 AM'}
      value ={ props.value}
    />
  )
}
export default TimePicker
